import {Nullish} from 'shared/web';

/**
 * Feature subcategory from the vehicle catalogue (`feature_category` key whose `parent` is a top-level category).
 */
export type FeatureSubCategory = {
  key: string;
  label: string;
  parent: string | Nullish;
};
